class HalloweenExclusiveCarousel {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('[data-exclusive-carousel-slide]'));
    this.previousButton = element.querySelector('[data-exclusive-carousel-previous]');
    this.nextButton = element.querySelector('[data-exclusive-carousel-next]');
    this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
    this.timer = null;
    this.mobileQuery = window.matchMedia('(max-width: 810px)');
    this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (this.slides.length < 2 || !this.previousButton || !this.nextButton) return;

    this.handleClick = this.handleClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.element.addEventListener('click', this.handleClick);
    this.mobileQuery.addEventListener('change', this.handleViewportChange);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.updateSlides();
    this.startAutoplay();
  }

  // 使用事件委托处理左右切换，并在手动切换后重新开始五秒计时。
  handleClick(event) {
    if (event.target.closest('[data-exclusive-carousel-previous]')) {
      this.showSlide(this.currentIndex - 1);
    } else if (event.target.closest('[data-exclusive-carousel-next]')) {
      this.showSlide(this.currentIndex + 1);
    }
  }

  showSlide(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.updateSlides();
    this.startAutoplay();
  }

  updateSlides() {
    const isMobile = this.mobileQuery.matches;
    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(isMobile && !isActive));
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    if (!this.mobileQuery.matches || this.reducedMotionQuery.matches || document.hidden) return;
    this.restartProgress();
    this.timer = window.setTimeout(() => this.showSlide(this.currentIndex + 1), 5000);
  }

  stopAutoplay() {
    if (this.timer) window.clearTimeout(this.timer);
    this.timer = null;
    this.element.classList.remove('is-autoplaying');
  }

  restartProgress() {
    this.element.classList.remove('is-autoplaying');
    requestAnimationFrame(() => requestAnimationFrame(() => this.element.classList.add('is-autoplaying')));
  }

  handleViewportChange() {
    this.updateSlides();
    this.startAutoplay();
  }

  handleVisibilityChange() {
    if (document.hidden) this.stopAutoplay();
    else this.startAutoplay();
  }
}

const initializeHalloweenExclusiveCarousels = (root = document) => {
  root.querySelectorAll('[data-halloween-exclusive-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';
    new HalloweenExclusiveCarousel(carousel);
  });
};

if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => initializeHalloweenExclusiveCarousels(), { timeout: 800 });
} else {
  window.requestAnimationFrame(() => initializeHalloweenExclusiveCarousels());
}

document.addEventListener('shopify:section:load', (event) => initializeHalloweenExclusiveCarousels(event.target));
